const redrawOnSelect = (params) => {
  params.api.forEachNode((node) => {
    const el = node.data;
    delete el.dirty;
    node.setData(el);
  });
  params.node.setData({
    ...params.data,
    dirty: true,
  });
  // refresh textual fields that have color changes (for example: from cyan to white)
  params.api.refreshCells({
    force: true,
    rowNodes: [params.node],
    columns: ["totalTime", "costsUnit", "totalcost", 'totalPrice', 'raise', 'vat'],
  });
};

export default redrawOnSelect;
